import { useParams, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import axios from "axios";
import s from './TourDetails.module.scss';

const Label = ({ htmlFor, children, required }: { htmlFor: string; children: string; required?: boolean }) => (
  <label htmlFor={htmlFor} className={s.label}>
    {children}
    {required && <span className={s.required}>※</span>}
  </label>
);

const TourDetailsCreate = () => {
  const { tour_id } = useParams();
  const [tourDetailId, setTourDetailId] = useState(null);
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const [details, setDetails] = useState({
    tour_id: tour_id,
    title: "",
    duration_minutes: "",
    is_discounted: false,
    description: "",
    warning: "",
    notes: "",
    about_price: "",
    items: ""
  });
  const [options, setOptions] = useState([])
  const [otherInfo, setOtherInfo] = useState([]);
  const [qa, setQa] = useState([]);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setDetails((prevDetails) => ({
      ...prevDetails,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleOptionsChange = (index, field, value) => {
    const updatedOptions = [...options];
    if(updatedOptions[index]) {
      updatedOptions[index][field] = value;
      setOptions(updatedOptions);
    }
  };

  const handleOptionsAddRow = () => {
    setOptions((prevOptions) =>
      Array.isArray(prevOptions) ? [...prevOptions, { name: "", price: null, remarks: "" }] : [{ name: "", price: null, remarks: "" }]
    );
  };

  const handleOptionsDeleteRow = (index) => {
    const updatedOptions = options.filter((_, i) => i !== index);
    setOptions(updatedOptions);
  };

  const handleInfoChange = (index, field, value) => {
    const updatedInfos = [...otherInfo];
    if (updatedInfos[index]) {
      updatedInfos[index][field] = value;
      setOtherInfo(updatedInfos);
    }
  };
  const handleInfoAddRow = () => {
    setOtherInfo((prevState) => Array.isArray(prevState) ? [...prevState, { label: "", value: "" }] : [{ label: "", value: "" }]);
  };

  const handleInfoDeleteRow = (index) => {
    const updatedInfos = otherInfo.filter((_, i) => i !== index);
    setOtherInfo(updatedInfos);
  };

  const handleQaChange = (index, field, value) => {
    const updatedQa = [...qa];
    if(updatedQa[index]){
      updatedQa[index][field] = value;
      setQa(updatedQa);
    }

  };

  const handleQaAddRow = () => {
    setQa((prevQa) =>
      Array.isArray(prevQa) ? [...prevQa, { answer: "", question: "" }] : [{ answer: "", question: "" }]
    );
  };

  const handleQaDeleteRow = (index) => {
    const updatedQa = qa.filter((_, i) => i !== index);
    setQa(updatedQa);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      // FormDataを作成
      const formData = new FormData();
      formData.append('tour_id', tour_id);
      formData.append('title', details.title || '');
      formData.append('duration_minutes', details.duration_minutes || '');
      formData.append('description', details.description || '');
      formData.append('warning', details.warning || '');
      formData.append('notes', details.notes || '');
      formData.append('about_price', details.about_price || '');
      formData.append('items', details.items || '');
      formData.append('is_discounted', details.is_discounted ? 1 : 0);

      // オプション情報があれば追加
      if (otherInfo && otherInfo.length > 0) {
        formData.append('other_info', JSON.stringify(otherInfo));
      }

      if (options && options.length > 0) {
        formData.append('options', JSON.stringify(options));
      }

      if (qa && qa.length > 0) {
        formData.append('qa', JSON.stringify(qa));
      }

      console.log('qa', qa)
      console.log('options', options)
      console.log('otherInfo', otherInfo)

      // POSTリクエストを送信
      const response = await axios.post(`${apiUrl}/api/admin/tour-details/create`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data', // FormDataを送る際はmultipart/form-data
        },
        maxContentLength: 50 * 1024 * 1024,
        maxBodyLength: 50 * 1024 * 1024,
      });

      // const result = await response.json();
      if (response.status === 201) {
        setSuccessMessage(response.data.message)
        setTourDetailId(response.data.tour.id);
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        setError("ツアー詳細の作成に失敗しました");
      }

      // 作成されたツアー詳細ページに遷移
      // navigate(`/tour-details/${response.data.id}`);
    } catch (error) {
      // エラーメッセージ
      setError("ツアー詳細の作成に失敗しました");
      console.error("Error creating tour details:", error);
    } finally {
      setLoading(false);
    }

  };

  return (
    <div className={s.root}>
      <button onClick={() => navigate("/")} className={s.backButton}>
        ホームに戻る
      </button>
      <button
        onClick={() => navigate(`/plans/${tourDetailId}`)}
        className={s.planButton}
      >
        プラン編集
      </button>
      <h2>ツアー詳細を作成</h2>
      <form onSubmit={handleSubmit}>
        {error && <div className={s.error}>{error}</div>}
        {successMessage && <div className={s.success}>{successMessage}</div>}
        <div className={s.formGroupContainer}>
          <div className={s.flex}>
          <div className={s.formGroup}>
              <Label htmlFor="title" required>
                タイトル
              </Label>
              <input
                type="text"
                id="title"
                name="title"
                value={details.title}
                onChange={handleChange}
                required
                className={s.input}
              />
            </div>
            <div className={s.formGroup}>
              <Label htmlFor="time" required>
                時間
              </Label>
              <input
                type="text"
                id="time"
                name="duration_minutes"
                value={details.duration_minutes}
                onChange={handleChange}
                required
                className={s.timeInput}
              />
            </div>
            <div className={s.formGroup}>
              <Label htmlFor="is_discounted">
                複数割引
              </Label>
              <input
                type="checkbox"
                id="is_discounted"
                name="is_discounted"
                checked={details.is_discounted}
                onChange={handleChange}
                className={s.checkbox}
              />
            </div>
          </div>
          <div className={s.flex}>
            <div className={s.formGroup}>
              <Label htmlFor="description" required>
                説明
              </Label>
              <textarea
                id="description"
                name="description"
                value={details.description}
                onChange={handleChange}
                required
                className={s.textarea}
              />
            </div>
            <div className={s.formGroup}>
              <Label htmlFor="warning">
                注意事項
              </Label>
              <textarea
                id="warning"
                name="warning"
                value={details.warning}
                onChange={handleChange}
                className={s.textarea}
              />
            </div>
          </div>
          <div className={s.flex}>
            <div className={s.formGroup}>
              <Label htmlFor="notes">
                ノート
              </Label>
              <textarea
                id="notes"
                name="notes"
                value={details.notes}
                onChange={handleChange}
                className={s.textarea}
              />
            </div>
            <div className={s.formGroup}>
              <Label htmlFor="about_price">
                料金について
              </Label>
              <textarea
                id="about_price"
                name="about_price"
                value={details.about_price}
                onChange={handleChange}
                className={s.textarea}
              />
            </div>
          </div>
          <div className={s.flex}>
            <div className={s.formGroup}>
              <Label htmlFor="items">
                持ち物
              </Label>
              <textarea
                id="items"
                name="items"
                value={details.items}
                onChange={handleChange}
                className={s.textarea}
              />
            </div>
          </div>
        </div>
        <div className={s.optionsContainer}>
          <h2 className={s.left}>オプション</h2>
          <table className={s.table}>
            <thead>
              <tr>
                <th>名前</th>
                <th>備考</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              {options.map((option, index) => (
                <tr key={index}>
                  <td>
                    <input
                      type="text"
                      value={option.name || ""}
                      onChange={(e) => handleOptionsChange(index, "name", e.target.value)}
                      className={s.input}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={option.remarks || ""}
                      onChange={(e) => handleOptionsChange(index, "remarks", e.target.value)}
                      className={s.input}
                    />
                  </td>
                  <td>
                    <button onClick={() => handleOptionsDeleteRow(index)} type="button" className={s.deleteButton}>
                      削除
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <button onClick={handleOptionsAddRow} type="button" className={s.addButton}>
            行を追加
          </button>
        </div>

        <div className={s.optionsContainer}>
          <h2 className={s.left}>その他情報</h2>
          <table className={s.table}>
            <thead>
              <tr>
                <th>タイトル</th>
                <th>値</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              {otherInfo.map((info, index) => (
                <tr key={index}>
                  <td>
                    <input
                      type="text"
                      value={info.label || ""}
                      onChange={(e) => handleInfoChange(index, "label", e.target.value)}
                      className={s.input}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={info.value || ""}
                      onChange={(e) => handleInfoChange(index, "value", e.target.value)}
                      className={s.input}
                    />
                  </td>
                  <td>
                    <button onClick={() => handleInfoDeleteRow(index)} type="button" className={s.deleteButton}>
                      削除
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <button onClick={handleInfoAddRow} type="button" className={s.addButton}>
            行を追加
          </button>
        </div>

        <div className={s.optionsContainer}>
          <h2 className={s.left}>質問と回答</h2>
          <table className={s.table}>
            <thead>
              <tr>
                <th>質問</th>
                <th>回答</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              {qa.map((qaItem, index) => (
                <tr key={index}>
                  <td>
                    <input
                      type="text"
                      value={qaItem.question || ""}
                      onChange={(e) => handleQaChange(index, "question", e.target.value)}
                      className={s.input}
                    />
                  </td>
                  <td>
                    <textarea
                      type="text"
                      value={qaItem.answer || ""}
                      onChange={(e) => handleQaChange(index, "answer", e.target.value)}
                      className={s.input}
                    />
                  </td>
                  <td>
                    <button onClick={() => handleQaDeleteRow(index)} type="button" className={s.deleteButton}>
                      削除
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <button onClick={handleQaAddRow} type="button" className={s.addButton}>
            行を追加
          </button>
        </div>
        <button type="submit" className={s.saveButton} disabled={loading}>
          {loading ? "作成中..." : "作成"}
        </button>
      </form>
    </div>
  );
};

export default TourDetailsCreate;
